<template lang="pug">
v-card
  a(href="" id="export" ref="exportLink" hidden)
  v-card-title
    v-text-field(
      dense
      v-model="search"
      append-icon="mdi-magnify"
      label="Search"
      single-line
      hide-details)
    v-card-text
      h2(class="text-h6 mb-2")
        | Filtre las secciones
      v-chip-group(
        v-model="visibleSections"
        item-value="key"
        column
        multiple)
        v-chip(
          :key="s.key"
          :value="s.key"
          class="white--text"
          v-for="s in mapSections"
          :color="s.vueColor"
          filter) <b>{{s.title}} ({{ s.variables.length }} variables)</b>
  v-data-table(
    style="border-collapse: collapse!important;"
    dense
    :headers="mapHeaders"
    :items="reportData.report_data"
    :search="search"
    hide-default-header)
    //- SLOT header
    template(v-slot:header)
      thead
        tr
          //- th(class="primary white--text") Enero
          //- th(class="blue lighten-2 text-center") Febrero
          th(
            v-if="visibleSections.includes(v.key)"
            style="border: 1px solid white!important;"
            :key="v.key"
            :class="`white--text ${v.vueColor} text-center`"
            v-for="v in mapSections"
            :colspan="v.variables.length") <b>{{v.title}}</b>
        tr
          th(
            style="border: 1px solid white!important;"
            :key="h.value"
            :class="`white--text ${h.color}`"
            v-if="visibleSections.includes(h.sectionKey)"
            v-for="h in mapHeaders") {{h.text}}

    //- SLOTS para las filas
    template(
      v-if="headers.filter((x) => x.value === 'complementacion').length > 0"
      v-slot:item.complementacion="{ item }")
      text-cutter(
        v-if="item.complementacion"
        :text="item.complementacion"
        :text-length="50"
        modal-title="Complementación")
    template(
      v-slot:item.fixed_numero_matricula="{ item }")
      b {{ item.fixed_numero_matricula }}
    template(
      v-if="headers.filter((x) => x.value === 'linderos_geos').length > 0"
      v-slot:item.linderos_geos="{ item }")
      span {{ item.linderos_geos }}
      v-btn(
        v-if="item.linderos_geos.includes('urn:ogc:def:crs:OGC:1.3:CRS84')"
        class="ml-2 white--text"
        small
        @click="downloadJson(item)"
        color="blue"
      ) Descargar GeoJSON
    template(
      v-if="headers.filter((x) => x.value === 'cabida').length > 0"
      v-slot:item.cabida="{ item }")
      text-cutter(
        v-if="item.cabida"
        :text="item.cabida"
        :text-length="50"
        modal-title="Cabida")
    template(
      v-if="headers.filter((x) => x.value === 'linderos_tecnicos').length > 0"
      v-slot:item.linderos_tecnicos="{ item }")
      text-cutter(
        v-if="item.linderos_tecnicos"
        :text="item.linderos_tecnicos"
        :text-length="50"
        modal-title="Linderos Tecnicos")
    template(
      v-if="headers.filter((x) => x.value === 'rt_beneficiario').length > 0"
      v-slot:item.rt_beneficiario="{ item }")
      div(
        v-for="(persona, index) in item.rt_beneficiario"
        :key="index"
        class="d-flex align-center my-1")
        v-chip(
          x-small
          outlined
          color="primary"
          class="mr-2"
          style="min-width: 90px; justify-content: center;")
          | {{ persona.rol }}
        span(class="font-weight-medium mr-2")
          | {{ persona.nombres_persona }}
        span(class="grey--text text--darken-1 text-caption")
          | CC: {{ persona.identificacion }}
        span(
          v-if="persona.contacto"
          class="ml-2 text-caption")
          v-icon(x-small) mdi-phone
          | {{ persona.contacto }}
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import TextCutter from '@/components/TextCutter';

export default {
  name: 'ReportPreview',

  components: {
    TextCutter,
  },

  data () {
    return {
      search: '',
    }
  },

  computed: {
    ...mapState('reports', ['reportData', 'listSections']),
    ...mapGetters('reports', [
      'mapSections',
      'mapHeaders'
    ]),
    headers() {
      const headers = this.reportData.headers.map((x) => {return {text: x.name, value: x.variable}});
      return headers;
    },
    visibleSections: {
      get() {
        return this.$store.state.reports.visibleSections;
      },
      set(value) {
        return this.$store.commit('reports/CHANGE_VALUE', {
          value,
          varName: 'visibleSections'
        });
      }
    }
  },

  methods: {
    downloadJson(item) {
      const jsonFile  = item.linderos_geos;
      const today = new Date();
      let fileName = '';
      if  (item.numero_matricula) {
        fileName = item.numero_matricula;
      } else {
        let formatDate = today.toISOString().replace('T', '_').replace('Z', '');
        fileName = `coordenadas_predio_${formatDate}`;
      }
      var convertedData = 'application/json;charset=utf-8,' + encodeURIComponent(jsonFile);
      document.getElementById('export').setAttribute('href', 'data:' + convertedData); 
      document.getElementById('export').setAttribute('download',
        `${fileName}.geojson`);
      this.$refs.exportLink.click();
    }
  }
}
</script>

<style scoped>
th {
  border: 2px solid blue;
  padding: 8px;
}
</style>